import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'manage-button',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="d-flex align-items-center btn-gap flex-wrap">
      <button
        class="dp-secondary-btn btn-padding"
        (click)="onCellClick(rowData, 'showPermissions')"
      >
        <img src="../../assets/images/edit.svg" />
      </button>
      <button
        class="dp-secondary-btn btn-padding"
        (click)="onCellClick(rowData, 'delete')"
      >
        <img src="../../assets/images/delete-destructive.svg" />
      </button>
    </div>
  `,
  styles: [
    `
      .btn-gap {
        gap: 12px;
      }

      .btn-padding {
        padding: 10px 8px 11px 8px;
      }
    `,
  ],
})
export class ManageUserRolesCellComponent {
  @Input() rowData: any;
  @Output() cellClick: EventEmitter<any> = new EventEmitter<any>();

  onCellClick(rowData: any, actionType: string) {
    this.cellClick.emit({ rowData, actionType });
  }
}
